import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router';
import { api, describeAuthRefusal } from '@/lib/api';
import { AuthCard } from './AuthCard';

/**
 * Forced password change after the bootstrap login. The backend marks
 * `MustChangePassword = true` on bootstrap-created accounts; this page
 * clears the flag and routes the operator into MFA enroll.
 */
export function PasswordChangePage() {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);

    if (password !== confirm) {
      setError('A confirmação não confere.');
      return;
    }
    if (password.length < 10) {
      setError('A senha precisa de pelo menos 10 caracteres.');
      return;
    }

    setSubmitting(true);
    try {
      // The /change-password endpoint requires PlatformJwt. During bootstrap
      // login we don't have one yet — the backend lets MustChangePassword
      // accounts call it via the login intent in body (design 1.10).
      await api.post('/platform/auth/change-password', { newPassword: password });
      navigate('/login/mfa-enroll');
    } catch (err) {
      setError(describeAuthRefusal(err));
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <AuthCard
      title="Troca de senha obrigatória"
      subtitle="Defina uma nova senha antes de continuar."
    >
      <form onSubmit={onSubmit}>
        {error && <div className="error-banner">{error}</div>}

        <div className="field">
          <label htmlFor="password">Nova senha</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            required
          />
        </div>

        <div className="field">
          <label htmlFor="confirm">Confirmar nova senha</label>
          <input
            id="confirm"
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
            required
          />
        </div>

        <button type="submit" className="btn" style={{ width: '100%' }} disabled={submitting}>
          {submitting ? 'Salvando…' : 'Salvar e continuar'}
        </button>
      </form>
    </AuthCard>
  );
}
